import React, { Component } from 'react';

var ListBlock = React.createClass({

  actionNext: function(){
    this.props.handleNextPage();
  },
  actionBack: function(){
    this.props.handleBackPage();
  },
  actionClickElement: function(){
    if(this.props.data && !this.props.data.empty){
        this.props.actionClickElement(this.props.data);
    }
  },
	render: function(){
    if(this.props.next){
      return (
  	      <div className="ListBlock Next" onClick={this.actionNext}>
            <div className="wrapper">
              <span className="name">
                <i style={{fontSize: 100}} className="fa fa-angle-right"></i>
              </span>
            </div>
          </div>
  		);
    }else if(this.props.back){
      return (
  	      <div className="ListBlock Back"  onClick={this.actionBack}>
            <div className="wrapper">
              <span className="name">
                <i style={{fontSize: 100}} className="fa fa-angle-left"></i>
              </span>
            </div>
          </div>
  		);
    }else if(this.props.reload){
      return (
  	      <div className="ListBlock Reload"  onClick={this.actionBack}>
            <div className="wrapper">
              <span className="name">
                <i  style={{fontSize: 68, fontWeight: 'bold'}} class='fas'>&#xf2f9;</i>
              </span>
            </div>
          </div>
  		);
    }else{
      return (
  	      <div className="ListBlock" onClick={this.actionClickElement}>
            <div className="wrapper">
              <span className="name">
                {this.props.data}
              </span>
            </div>
          </div>
  		);
    }
	}
})

export default ListBlock;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/List/components/ListBlock/index.jsx
 **/